import { render, staticRenderFns } from "./PreviewSK.vue?vue&type=template&id=554a108c&scoped=true&"
import script from "./PreviewSK.vue?vue&type=script&lang=js&"
export * from "./PreviewSK.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSK.vue?vue&type=style&index=0&id=554a108c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554a108c",
  null
  
)

export default component.exports